import React, { useState } from 'react';
import { faqs } from '../data';

const FAQs = () => {
  const [openQuestionIndex, setOpenQuestionIndex] = useState(null);

  const toggleQuestion = (index) => {
    setOpenQuestionIndex(openQuestionIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-3 lg:py-12">
      <div className="w-full lg:w-[60%] p-4">
        <h1 className="text-3xl lg:text-4xl font-bold text-center mb-8 lg:mb-12">Frequently Asked Questions</h1>
        {faqs.map((faq, index) => (
          <div key={index} className="mb-4">
            <button
              onClick={() => toggleQuestion(index)}
              className="w-full text-left text-xl font-medium bg-gray-200 p-4 rounded-md flex justify-between items-center"
            >
              <span>{faq.question}</span>
              <span className="text-2xl">
                {openQuestionIndex === index ? '-' : '+'}
              </span>
            </button>
            {openQuestionIndex === index && (
              <div className="mt-2 p-4 bg-gray-100 rounded-md text-gray-700 w-full">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQs;
